// ⭐ Valores personalizados estilo GHL (pedido de Angelo, 2026-08-07: "algo
// como {{contact.name}}, que sea como la interfaz de GHL mismo"). Fuente
// única para el picker que se usa en 3 lugares: el editor de plantillas
// (WorkflowsManager.js), el input de mensaje manual en Conversaciones.js, y
// el panel de configuración del paso "Enviar mensaje" del constructor de
// workflows. El render REAL (el que de verdad se manda al contacto) vive en
// el backend -- ver CUSTOM_VALUE_FIELDS/renderTemplate en
// backend/crm/workflowEngine.js, que es la fuente de la verdad. Esta copia
// del lado del cliente es solo para: (a) la lista que ve el picker, y (b)
// una vista previa inmediata en Conversaciones.js antes de mandar (mismo
// patrón ya usado en el proyecto para constantes chicas duplicadas cliente/
// servidor, ver TEMPERATURE_OPTIONS en Conversaciones.js/PipelineManager.js).
// Si se agrega un campo acá, hay que agregarlo también en el backend.
export const CUSTOM_VALUES = [
  { key: 'contact.name', legacy: 'nombre', label: 'Nombre del contacto' },
  { key: 'contact.phone', legacy: 'telefono', label: 'Teléfono' },
  { key: 'contact.email', label: 'Email' },
  { key: 'contact.cedula', label: 'Cédula' },
  { key: 'contact.sector', label: 'Sector' },
  { key: 'contact.birthday', label: 'Cumpleaños' },
];

// Inserta `text` en la posición del cursor de un <input>/<textarea>
// controlado por React (en vez de simplemente concatenar al final) -- así
// el picker funciona igual que en GHL: el agente puede pararse en medio del
// texto ya escrito y el valor se inyecta ahí, no al final.
export function insertAtCursor(ref, currentValue, setValue, textToInsert) {
  const el = ref?.current;
  if (!el || typeof el.selectionStart !== 'number') {
    setValue(`${currentValue || ''}${textToInsert}`);
    return;
  }
  const start = el.selectionStart;
  const end = el.selectionEnd;
  const next = `${currentValue.slice(0, start)}${textToInsert}${currentValue.slice(end)}`;
  setValue(next);
  const cursorPos = start + textToInsert.length;
  // El re-render de React todavía no aplicó el nuevo value al DOM en este
  // mismo tick -- setSelectionRange hay que hacerlo después, en el próximo
  // frame, si no el cursor queda mal posicionado (o el navegador lo ignora).
  requestAnimationFrame(() => {
    el.focus();
    try { el.setSelectionRange(cursorPos, cursorPos); } catch (_) { /* ignorar en inputs que no soportan selección */ }
  });
}

// Vista previa client-side (el envío real siempre re-renderiza en el
// backend, esto es solo para que el agente vea el texto resuelto antes de
// mandar, ver insertTemplate en Conversaciones.js).
export function previewCustomValues(content, contact) {
  let out = String(content || '');
  const values = {
    'contact.name': contact?.name || contact?.phone || '',
    'contact.phone': contact?.phone || '',
    'contact.email': contact?.email || '',
    'contact.cedula': contact?.cedula || '',
    'contact.sector': contact?.sector || '',
    'contact.birthday': contact?.birthday || '',
    nombre: contact?.name || contact?.phone || '',
    telefono: contact?.phone || '',
  };
  for (const [key, value] of Object.entries(values)) {
    out = out.replace(new RegExp(`\\{\\{\\s*${key.replace('.', '\\.')}\\s*\\}\\}`, 'gi'), value);
  }
  return out;
}
